module.exports = __webpack_public_path__ + "r-v3/img/figures_blue.011c2e11.svg";